import PropTypes from 'prop-types';
import React from 'react';
import { ACCESS_DENIED, ACCESS_NO_LOGIN, STATUS_DENIED, STATUS_WAITING } from '../utlities/core.constants';
import StatusBar from './StatusBar.component';
import { SectionContainer } from '../pages/shared.styled';

export default function AccessStatus({access = ''}){
  if(access === ACCESS_NO_LOGIN){
    return <SectionContainer> <StatusBar status={STATUS_DENIED} title="Access Request Denied" description="Sign in required." /></SectionContainer>
  }

  if(access === ACCESS_DENIED){
    return <SectionContainer> <StatusBar status={STATUS_DENIED} title="Access Request Denied" description="You don't have permission to access this page." /></SectionContainer>
  }

  return <SectionContainer className='mb-0 pb-0'><StatusBar status={STATUS_WAITING} title="Pending" description="Your request for access is pending approval." /></SectionContainer>
}

AccessStatus.propTypes = {
  access: PropTypes.string
}
